var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Avatar } from 'antd';
import React from 'react';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { UserAvatar } from './UserAvatar';
export const StakeholderAvatarGroup = (_a) => {
    var { large, stakeholders } = _a, rest = __rest(_a, ["large", "stakeholders"]);
    return React.createElement(Avatar.Group, Object.assign({}, rest), stakeholders.map((sh) => {
        if (sh.userId === null || sh.userId === undefined) {
            return (React.createElement(SonarStakeholder, { key: sh.stakeholderId, large: large, showTooltip: true, stakeholderId: sh.stakeholderId, withFullName: false }));
        }
        return React.createElement(UserAvatar, { key: sh.userId, large: large, userId: sh.userId });
    }));
};
